module.exports = {
	"root": "findify-components--cards--product",
	"simple": "findify-components--cards--product__simple",
	"image-wrap": "findify-components--cards--product__image-wrap",
	"imageWrap": "findify-components--cards--product__image-wrap",
	"image": "findify-components--cards--product__image",
	"content": "findify-components--cards--product__content",
	"title": "findify-components--cards--product__title",
	"description": "findify-components--cards--product__description",
	"rating": "findify-components--cards--product__rating",
	"price-wrapper": "findify-components--cards--product__price-wrapper",
	"priceWrapper": "findify-components--cards--product__price-wrapper",
	"color": "findify-components--cards--product__color",
	"out-of-stock": "findify-components--cards--product__out-of-stock",
	"outOfStock": "findify-components--cards--product__out-of-stock",
	"discount-sticker": "findify-components--cards--product__discount-sticker",
	"discountSticker": "findify-components--cards--product__discount-sticker",
	"variants": "findify-components--cards--product__variants"
};